<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          color="primary"
          class="text-unset"
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
          >{{ $t(buttonText) }}</v-btn
        >
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ $t(buttonText) }}
        </v-card-title>

        <v-card-text class="text-center py-4">
          <p>{{ $t(qrInstructions) }}</p>

          <!-- Tukaj se pokaže QR koda (prikazana samo, če imamo uid in sliko) -->
          <div v-if="qrImageUrl" class="qr-container">
            <img :src="qrImageUrl" alt="QR Koda" class="qr-image" />
          </div>
          <div v-if="qrImageUrl">
            <span style="font-size: x-large; margin-top: 20px">
              {{ this.getClassification(this.shopItemTxtId) + this.uid }}
            </span>
          </div>
          <div v-else class="text-muted">Nalaganje QR kode...</div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" class="text-unset">
            {{ $t("common.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  props: ["buttonText", "uid", "disabled", "qrInstructions", "shopItemTxtId"],
  data() {
    return {
      dialog: false,
      quantity: 0,
      user: null,
      qrImageUrl: "", // Tukaj shranimo Data URL generirane QR kode
    };
  },
  watch: {
    // Spremljamo, kdaj se dialog odpre, in takoj generiramo QR kodo na podlagi uid-ja
    dialog(isOpen) {
      console.log("dialog(isOpen)", isOpen);
      if (isOpen && this.uid) {
        this.generateQrCode();
      }
    },
    // Če bi se uid slučajno spremenil, medtem ko je dialog odprt
    uid(newUid) {
      console.log("sprememba uid", newUid, "dialog", this.dialog);
      if (this.dialog && newUid) {
        this.generateQrCode();
      }
    },
  },
  methods: {
    getClassification(txtId) {
      // 1. Varnostno preverjanje: če je txtId prazen, null, undefined ali ni niz, vrnemo prazen niz
      if (!txtId || typeof txtId !== "string") {
        return "";
      }

      // 2. Preverjanje začetka niza (pretvorimo v male črke za večjo robustnost)
      const firstLetter = txtId.charAt(0).toLowerCase();

      if (firstLetter === "t") {
        return "T";
      } else if (firstLetter === "p") {
        return "P";
      }

      // 3. Za vse ostale vrednosti vrnemo prazen niz
      return "";
    },
    async generateQrCode() {
      try {
        console.log("zagon generateQrCode");
        // Generiramo QR kodo neposredno iz vrednosti prop-a `uid`
        const classif = this.getClassification(this.shopItemTxtId);
        this.qrImageUrl = await QRCode.toDataURL(classif + String(this.uid), {
          width: 220,
          margin: 2,
        });
      } catch (error) {
        console.error("Napaka pri generiranju QR kode:", error);
      }
    },
  },
};
</script>

<style scoped>
.qr-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.qr-image {
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>